var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('span',[_c('v-avatar',{attrs:{"size":"32px"}},[_c('img',{attrs:{"src":_vm.user.photoURL}})]),_c('span',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.user.name)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }